export default {
    appName: "Kobowork",
    domain: process.env.NODE_ENV == 'production' ? 'https://www.kobowork.com' : 'http://127.0.0.1:8000',
    localUserKey: "sta_web_udt_mk"
}
